<template>
  <nav class="grid-x align-center client-logos">
    <div class="cell medium-offset-0 medium-9 middle-offset-0 middle-12 large-offset-0 large-12">
      <div class="grid-x small-up-2 medium-up-2 middle-up-4 large-up-4 align-middle logo-links">
        <slot></slot>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
  }
</script>

<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import '../css/settings';
  @import '../css/colors';

  .client-logos {
    margin-top: 2rem;
  }

  .logo-links {
    padding-left: 12px;
    margin: 6px auto 24px auto;
    // same thing on next to,
    // foundation's way of mixin vs
    // putting class in element (up the html .align-center)  vs
    // just using the property
    @include flex-align(center);
    /*justify-content: center;*/

    @include breakpoint(small) {
      padding-left: 0;
    }

    a {
      padding: 10px 0;
      background-color: $logoBtn2;
      border-top: 1px solid $logoBtn1;
      border-right: 1px solid $deepBlack;
      border-bottom: 1px solid $deepBlack;

      &:hover {
        border-top: 1px solid $logoBtn0;
        //background-color: $logoBtn3;
        //background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.5) 100%);
        background: linear-gradient(180deg, $logoBtn0 0%, $logoBtn3 100%);
        //background: linear-gradient(to top, #1b1b1b 0%, #18181b 30%);
      }
    }

    img {
      display: block;
      width: 100%;
      margin: auto;
      max-width: 185px;
      @include breakpoint(small) {
        /*max-width: 100%;*/
        max-width: 185px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ClientLogos.vue